/**
 * @fileoverview GET handler for the "/api/calculated_attributes/:id/:app_group_id/user_lookup" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedAttributesIdAppGroupIdUserLookup } from "./constants";
import type {
  GetApiCalculatedAttributesIdAppGroupIdUserLookupProps,
  GetApiCalculatedAttributesIdAppGroupIdUserLookupResponse,
  GetApiCalculatedAttributesIdAppGroupIdUserLookupResultErrors,
} from "./types";
import { isGetApiCalculatedAttributesIdAppGroupIdUserLookupResponse } from "./validators";

// A live ClickHouse re-compute, not a profile read, so it can be slow and can time out (408).
// propagateFetchRequestError is off because every error this endpoint returns -- user not found,
// lookup failed, timed out -- is a state the lookup drawer renders itself. Left at its default
// they would open the global error modal and never reach the UI.
export const getApiCalculatedAttributesIdAppGroupIdUserLookup = reactQueryFetcherAdapter(
  apiCalculatedAttributesIdAppGroupIdUserLookup,
  createGetFetcherFunctionWithShadowError<GetApiCalculatedAttributesIdAppGroupIdUserLookupResultErrors>()(
    (
      signal: AbortSignal,
      props: GetApiCalculatedAttributesIdAppGroupIdUserLookupProps
    ): Promise<GetApiCalculatedAttributesIdAppGroupIdUserLookupResponse> => {
      const { id, appGroupId, userIdentifier } = props;
      const query = new URLSearchParams({ user_identifier: userIdentifier }).toString();
      return fetch(
        `/api/calculated_attributes/${id}/${appGroupId}/user_lookup?${query}`,
        "GET",
        undefined,
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetApiCalculatedAttributesIdAppGroupIdUserLookupResponse
);
